var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItem, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { useAppLocationMatcher, useAppLocationState } from '../app-location';
import { useHorizontalSubMenuContext } from './HorizontalSubMenuContext';
export var SubMenuItem = function (_a) {
    var value = _a.value, label = _a.label, MenuItemProps = _a.MenuItemProps, className = _a.className, props = __rest(_a, ["value", "label", "MenuItemProps", "className"]);
    var _b = useAppLocationState(), setLocation = _b[1];
    var match = useAppLocationMatcher();
    var horizontalSubMenuContext = useHorizontalSubMenuContext();
    var isSelected = match("".concat(horizontalSubMenuContext, ".").concat(value));
    return (_jsx(Root, { children: _jsx(StyledMenuItem, __assign({ className: clsx(className, isSelected ? SubMenuItemClasses.selected : ''), value: value, onClick: function () {
                return setLocation("".concat(horizontalSubMenuContext, ".").concat(value));
            }, component: Link }, MenuItemProps, props, { children: label })) }));
};
var PREFIX = 'RaHorizontalSubMenuItem';
var SubMenuItemClasses = {
    selected: "".concat(PREFIX, "-selected"),
};
var Root = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["& .".concat(SubMenuItemClasses.selected)] = {
            borderLeft: "2px solid ".concat(theme.palette.text.primary),
            fontWeight: 500,
        },
        _b);
});
var StyledMenuItem = styled(MenuItem)({
    fontSize: '0.875rem',
    lineHeight: '1.75',
    letterSpacing: '0.02857em',
    minHeight: '48px',
});
